import { FC } from 'react'

import { EmbroideryFormKind } from '../../../../containers/EmbroideryContainer/types'
import { B2BLogoEmbroideryForm } from '../forms/B2BLogoEmbroideryForm'
import { DTCLogoEmbroideryForm } from '../forms/DTCLogoEmbroideryForm'
import { IconEmbroideryForm } from '../forms/IconEmbroideryForm'
import { TextEmbroideryForm } from '../forms/TextEmbroideryForm'

const embroideryFormComponentsByKind: Record<EmbroideryFormKind, FC> = {
  ICON: IconEmbroideryForm,
  TEXT: TextEmbroideryForm,
  LOGO_B2B: B2BLogoEmbroideryForm,
  LOGO_SETUP: DTCLogoEmbroideryForm,
  LOGO_DTC: DTCLogoEmbroideryForm,
}

export const EmbroideryForm: FC<{ formKind: EmbroideryFormKind }> = ({ formKind }) => {
  const Form: FC = embroideryFormComponentsByKind[formKind]

  return <Form />
}
